import DefaultPasswordStatus from './DefaultPasswordStatus';

export default DefaultPasswordStatus;
